import { render, staticRenderFns } from "./DrawerImportModal.vue?vue&type=template&id=5a6a740b&scoped=true"
import script from "./DrawerImportModal.vue?vue&type=script&lang=js"
export * from "./DrawerImportModal.vue?vue&type=script&lang=js"
import style0 from "./DrawerImportModal.vue?vue&type=style&index=0&id=5a6a740b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a740b",
  null
  
)

export default component.exports